import React, { memo } from 'react'

import { graphql, Link } from 'gatsby'

import Img from '../components/Img'

const Socials = ({ slice }) => (
  <ul className="socials">
    {slice?.items.map((item) => (
      <li key={item} className="socials-item">
        <Link
          to={item?.social?.url}
          target={item?.social?.target}
          aria-label={item?.alt || 'Social Image'}
        >
          <Img
            image={item?.social_image?.gatsbyImageData}
            alt={item?.alt}
            className="mobile-thumbnail"
          />
        </Link>
      </li>
    ))}
  </ul>
)

export default memo(Socials)

export const query = graphql`
  fragment FooterDataBodySocials on PrismicFooterDataBodySocials {
    id
    items {
      social {
        id
        target
        url
      }
      social_image {
        gatsbyImageData
      }
    }
  }
`
